//
//
//
//
//
//
//
//
//
//

import Genesys from '@/scripts/libs/genesys'

export default {
  name: 'rb-pcp-promo-stripe-wrapper',
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    window.externalInvocationMethodMapping.showPromoStripe = () => {
      this.loading = false
    }

    window.externalInvocationMethodMapping.openGenesysChat = () => {
      Genesys.injectAndInit({ vuexStore: this.$store, multiAnalytics: this.$ma })
    }
    if (Genesys.genesysWasInitialized() && this.canShowGenesys) {
      Genesys.injectAndInit({ vuexStore: this.$store, multiAnalytics: this.$ma })
    }
  },
}
